var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
const textFieldSxProps = (isWarningState) => ({
    mt: 0,
    textOverflow: "ellipsis",
    overflow: "hidden",
    "&.MuiFormHelperText-root:not(.Mui-error)": {
        color: (theme) => isWarningState ? theme.palette.warning.main : "inherit"
    },
    "&.MuiFormHelperText-contained": {
        m: 0
    }
});
const helperTextContainerSxProps = (hasHelperText) => ({
    display: "flex",
    justifyContent: hasHelperText ? "space-between" : "end",
    width: "100%"
});
export const EnhancedTextField = (props) => {
    const { warning, limitCharacters } = props, textFieldProps = __rest(props, ["warning", "limitCharacters"]);
    const { focused, onChange, onKeyPress, onPaste, helperText, value } = textFieldProps;
    const [numberOfChars, setNumberOfChars] = useState((value === null || value === void 0 ? void 0 : value.length) || 0);
    useEffect(() => {
        var _a;
        setNumberOfChars((_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0);
    }, [value]);
    const handleValueChange = (e) => {
        onChange && onChange(e);
    };
    const handleKeyPress = (e) => {
        if (numberOfChars >= limitCharacters && e.target.selectionEnd - e.target.selectionStart == 0) {
            e.preventDefault();
        }
        onKeyPress && onKeyPress(e);
    };
    const handlePaste = (e) => {
        const clipBoardData = e.clipboardData.getData("text/plain");
        const selectedTextLength = e.target.selectionEnd - e.target.selectionStart;
        const maxPastingLength = limitCharacters - numberOfChars + selectedTextLength;
        if (clipBoardData.length > maxPastingLength) {
            e.preventDefault();
            if (maxPastingLength > 0) {
                setNumberOfChars(limitCharacters);
                e.target.value = [
                    e.target.value.slice(0, e.target.selectionStart),
                    clipBoardData.substring(0, maxPastingLength),
                    e.target.value.slice(e.target.selectionEnd, e.target.value.length)
                ].join("");
                handleValueChange(e);
            }
        }
        onPaste && onPaste(e);
    };
    return (_jsx(TextField, Object.assign({}, textFieldProps, { onChange: handleValueChange, onKeyPress: handleKeyPress, onPaste: handlePaste, InputLabelProps: props.InputLabelProps, FormHelperTextProps: {
            focused: warning || focused,
            // @ts-ignore For some reason component prop is not exposed by MUI types but works at runtime
            component: "div",
            sx: { display: "flex", alignItems: "center" }
        }, helperText: _jsxs(Box, { sx: helperTextContainerSxProps(!!helperText), children: [helperText ?
                    _jsx(Box, { sx: textFieldSxProps(warning), children: helperText })
                    : _jsx(_Fragment, {}), limitCharacters ?
                    _jsxs(Typography, { variant: "caption", sx: { ml: "8px" }, color: "text.secondary", children: [numberOfChars, "/", limitCharacters] })
                    : _jsx(_Fragment, {})] }) })));
};
export default EnhancedTextField;
//# sourceMappingURL=EnhancedTextField.js.map